// DO NOT CHANGE
// Compiled by gulp ngtemplates:module. Adds templates to $templateCache.

/* jshint ignore:start */
"use strict";

angular.module("saturn.filter").run(["$templateCache", function ($templateCache) {
  $templateCache.put("saturn/filter/search/search.tpl.html", "<div class=\"filter filter--search\">\n  <input ng-model=\"searchTerm\" placeholder=\"{{::placeholder}}\"/>\n  <div class=\"icon fa fa-icon-search\" />\n</div>");
}]);
/* jshint ignore:end */


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/filter/es5/templates.js